module.exports = __webpack_public_path__ + "img/65f6d18.jpg";